import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.actionFormController().addSuggestion('issues', this.element.dataset.name, this.element.dataset.rank, this.element.dataset.score, this.element.dataset.value)
  }

  addSuggestion(event) {
    this.actionFormController().suggestionSelected('issues', this.element.dataset.name, this.element.dataset.value)

    this.issuesTypeaheadController().selectOption(event)
    this.removeSuggestion(event.target)
  }

  removeSuggestion(target) {
    if ($(target).closest('ul')[0].childElementCount === 1) {
      $('.fieldset--issues-suggestions').parents('li').remove()
    } else {
      target.closest('li').remove()
    }
  }

  actionFormController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('action-form'), 'action-form')
  }

  issuesTypeaheadController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('issues'), 'atomic--organism--typeahead-multiselect--component')
  }
}
